<template>
  <PageWrapper
    :isLoading="isLoading"
    is-dense
    :hasFilters="$can('GetAll', 'Users')"
    @submitFilters="getAllAbsenceReportList"
  >
    <template #title> لیست غیبت های گزارش شده </template>
    <template #filters v-if="$can('GetAll', 'Users')">
      <StudentPicker
        @getStudentUserId="setStudentUserId"
        class="w-24 filters-width"
      ></StudentPicker>
      <MasterPicker
        @getMaster="setMasterUserId"
        class="w-24 filters-width"
      ></MasterPicker>
    </template>
    <CustomTable
      v-if="absenceReports"
      :pageNumber="absenceReportsListFilters.pageNumber"
      :count="absenceReportsListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="absenceReports"
      @changePage="changePage"
    >
      <template #startDate="data">
        {{ createLocaleDateTimeForSchedule(data.item) }}
      </template>
      <template #isPayBack="data">
        <BBadge :variant="data.item.isPayBack ? 'success' : 'danger'">
          {{ data.item.isPayBack ? "پرداخت شده" : "در انتظار بررسی" }}
        </BBadge>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllAbsenceReportList();
  },
  data() {
    return {
      absenceReports: null,
      totalCount: null,
      absenceReportsListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        masterUserId: null,
      },
      isLoading: false,
      tableColumns: [
        {
          key: "masterName",
          label: "نام استاد",
        },
        {
          key: "studentName",
          label: "نام زبان آموز",
        },
        {
          key: "startDate",
          label: "تاریخ جلسه",
        },
        {
          key: "isPayBack",
          label: "وضعیت",
        },
      ],
    };
  },
  methods: {
    renderConfirmAbsenceReportConfirmationDialog(absenceItem) {
      this.tempSelectedAbsence = absenceItem;
      this.$bvModal.show("confirm-absence-report-by-master");
    },
    createLocaleDateTimeForSchedule(schedule) {
      return `${new Date(schedule.startDate).toLocaleDateString(
        "fa-IR"
      )} - ${new Date(schedule.startDate).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      })} - ${new Date(schedule.endDate).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    },
    setMasterUserId(master) {
      this.absenceReportsListFilters.masterUserId = master
        ? master.userId
        : null;
    },
    setStudentUserId(studentUserId) {
      this.absenceReportsListFilters.studentUserId = studentUserId;
    },
    changePage(pageNumber) {
      this.absenceReportsListFilters.pageNumber = pageNumber;
      this.getAllAbsenceReportList();
    },
    async getAllAbsenceReportList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllSchedulePayBacks = new GetAllSchedulePayBacks(_this);
        getAllSchedulePayBacks.setRequestParam(_this.absenceReportsListFilters);
        await getAllSchedulePayBacks.fetch((res) => {
          _this.absenceReports = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BBadge,
    BButton,
    PageWrapper,
    SearchInput,
    CustomTable,
    StudentPicker,
    MasterPicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import StudentPicker from "@/views/components/Students/StudentPicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  GetAllSchedulePayBacks,
  VerifyMasterAbsenceReport,
} from "@/libs/Api/Schedules";
import { getUserData } from "@/auth/utils";
import { BBadge, BButton } from "bootstrap-vue";
</script>
